import { MeshProps } from '@react-three/fiber'
import { Suspense } from 'react'
import { useGetDoorProductPositionOffset } from '~/components/DrawingCanvas/Doors/hooks'
import { LoadingIndicator } from '~/components/DrawingCanvas/Products/components/LoadingIndicator'
import { useProductMesh } from '~/components/DrawingCanvas/Products/hooks/useProductMesh'
import { vectorModelToUI } from '~/components/DrawingCanvas/util/units'
import { doorProducts } from '~/config/doorProducts'
import { useAppSelector } from '~/store/hooks'
import { Door } from '~/store/objects/types'

type DoorProductProps = MeshProps & { door: Omit<Required<Door>, 'metadata'> }

export const DoorProduct = (props: DoorProductProps) => {
  const getPositionOffset = useGetDoorProductPositionOffset()
  const doorProductLayerKey =
    doorProducts.find(({ name }) => name === props.door.product.name)?.category ?? 'PRODUCTS_DIRECTIONAL'
  const isVisible = useAppSelector(state => state.layers.layers[doorProductLayerKey].visible)
  const position = vectorModelToUI(props.door.position)
  const offset = getPositionOffset(props.door)
  position.add(offset)
  return (
    <Suspense fallback={<LoadingIndicator position={position} />}>
      <DoorProductMesh
        visible={isVisible}
        position={position}
        rotation-z={props.door.rotation._z}
        scale-x={props.door.product.orientation === 'right' ? -1 : 1}
        {...props}
      />
    </Suspense>
  )
}
const DoorProductMesh = ({ door, ...props }: DoorProductProps) => {
  const mesh = useProductMesh(door.product.name)
  return <primitive {...props} object={mesh} />
}
